import { visit } from "turbolinks";
import consumer from "./consumer"

consumer.subscriptions.create("VisitChannel", {
  connected() {
    // Called when the subscription is ready for use on the server
  },
  
  disconnected() {
    // Called when the subscription has been terminated by the server
  },
  
  received(data) {
    console.log('VisitChannel received data:', data);
    
    // Handle check-in notifications
    if (data.type === 'checkin_notification') {
      console.log('✅ Check-in notification received:', data);
      console.log('📍 Current path:', window.location.pathname);
      showCheckinNotificationInVisitChannel(data);
      return;
    }
    
    var ShowLabel = data.statusLable
    
    // for frontDesk or backoofice page
    var tableColumn =document.getElementById(data.field+'_'+data.visit_id)
    if(tableColumn){
      if(data.value=='true'){
        var iconMarked = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" fill="green">'+'<path d="M0 0h24v24H0z" fill="none"/><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"/></svg>'+ShowLabel
        tableColumn.innerHTML=iconMarked
      }
      else{
        var iconMarked = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" width="18" height="18" fill="green"><path fill-rule="evenodd" d="m5.965 4.904 9.131 9.131a6.5 6.5 0 0 0-9.131-9.131Zm8.07 10.192L4.904 5.965a6.5 6.5 0 0 0 9.131 9.131ZM4.343 4.343a8 8 0 1 1 11.314 11.314A8 8 0 0 1 4.343 4.343Z" clip-rule="evenodd" /></svg>'+ShowLabel
        tableColumn.innerHTML=iconMarked
      }
    }
    var timecolumn = document.getElementById(data.visit_id)
    var visitColumn = document.getElementById('highlight_'+data.visit_id)      
    // Show Notification
    if(data.value=='true'){
      // for notification
      var notification = document.getElementById('real_time')
      var notificationText = document.getElementById('real_time_text')
      if(notification && data.patient_name && data.value=='true'){
        var msg = "<b>"+data.patient_name +"'s</b> Status "+ShowLabel
        notificationText.innerHTML=msg
        notification.classList.remove('hide')
        setTimeout(()=>{
          notification.classList.add('hide')
        },5000)
      }
      // for remove hightlight the time column
      if(timecolumn){
        timecolumn.classList=''
        timecolumn.classList.add("time_column");
      }
      // for add class remove_highlight in Status column
      if(visitColumn){
        visitColumn.classList=''
        visitColumn.classList.add("remove_highlight");
      }
    }
    else if(data.value=='false'){
      if(timecolumn){
        var checkinPlusTime=$('#checkinPlus_'+data.visit_id)[0]
        checkinPlusTime=checkinPlusTime.querySelector("time").textContent;
        var checkinPlusTime30=$('#checkinPlus30_'+data.visit_id)[0]
        checkinPlusTime30=checkinPlusTime30.querySelector("time").textContent;
        const date = new Date();
        const year = date.getFullYear() - 2000; // Assuming 'yy' format means 2-digit years represent years after 2000
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');
        const currentTime= `${year}:${month}:${day}:${hours}:${minutes}:${seconds}`;
        const currentDate = parseCustomDateFormat(currentTime);
        const checkinDate = parseCustomDateFormat(checkinPlusTime);
        const checkinDate30 = parseCustomDateFormat(checkinPlusTime30);
        timecolumn.classList=''
        timecolumn.classList.add("time_column");
        if(checkinDate<=currentDate ){
          if(checkinDate30<=currentDate){
            timecolumn.classList.add("red_class");
          }
          else{
            timecolumn.classList.add("highlight_class");
          }
        }
      }
      // for add class remove_highlight in Status column
      if(visitColumn){
        console.log('visitcolumn')
        visitColumn.classList=''
        visitColumn.classList.add("no_idea");
      }
    }

    // Date  format for camparison
    function parseCustomDateFormat(dateString) {
      const parts = dateString.split(':');
      const year = parseInt(parts[0]) + 2000; // Assuming 'yy' format means 2-digit years represent years after 2000
      const month = parseInt(parts[1]) - 1; // Month is zero-based in JavaScript Date
      const day = parseInt(parts[2])-1;
      const hours = parseInt(parts[3]);
      const minutes = parseInt(parts[4]);
      const seconds = parseInt(parts[5]);
      return new Date(year, month, day, hours, minutes, seconds);
    }
    // Called when there's incoming data on the websocket for this channel
  }
});

// Handle check-in notifications in visit channel
function showCheckinNotificationInVisitChannel(data) {
  console.log('🔔 Displaying check-in notification:', data);
  
  // Only show notifications on dashboard/home pages, not on visit page
  const currentPath = window.location.pathname;
  console.log('📍 Current path for notification:', currentPath);
  
  if (currentPath === '/visit' || currentPath.includes('/visits/')) {
    console.log('❌ Skipping notification display on visit page');
    return;
  }
  
  console.log('✅ Path check passed, creating notification...');
  
  // Create notification element
  const notificationId = 'checkin-notification-' + Date.now();
  const isNewIcon = data.is_new_patient ? '🆕' : '👤';
  const bgColor = data.is_new_patient ? '#28a745' : '#007bff';
  const patientType = data.is_new_patient ? 'New Patient' : 'Returning Patient';
  
  const notification = `
    <div id="${notificationId}" class="checkin-notification" 
         style="position: fixed; top: 60px; right: 20px; 
                background: ${bgColor}; color: white; 
                padding: 15px 20px; border-radius: 8px; 
                z-index: 9999; min-width: 300px; max-width: 400px;
                box-shadow: 0 4px 12px rgba(0,0,0,0.3);
                border-left: 4px solid rgba(255,255,255,0.3);
                animation: slideInRight 0.5s ease-out;">
      <div style="display: flex; align-items: center; gap: 12px;">
        <div style="font-size: 24px;">${isNewIcon}</div>
        <div style="flex: 1;">
          <div style="font-weight: bold; font-size: 14px; margin-bottom: 4px;">
            ${patientType} Check-in
          </div>
          <div style="font-size: 13px; opacity: 0.9;">
            <strong>${data.patient_name}</strong> 
          </div>
          <div style="font-size: 12px; opacity: 0.8; margin-top: 2px;">
            ${data.visit_type} visit • ${data.checkin_time}
          </div>
        </div>
        <div style="cursor: pointer; font-size: 20px; opacity: 0.8; font-weight: bold;
                    padding: 2px 6px; border-radius: 3px; 
                    transition: all 0.2s ease;"
             onclick="closeCheckinNotification('${notificationId}')"
             onmouseover="this.style.opacity='1'; this.style.backgroundColor='rgba(255,255,255,0.2)'"
             onmouseout="this.style.opacity='0.8'; this.style.backgroundColor='transparent'">
          ×
        </div>
      </div>
    </div>
  `;
  
  // Add notification to page
  document.body.insertAdjacentHTML('beforeend', notification);
  
  // Play notification sound (optional)
  playNotificationSound();
  
  // Note: Notification stays until manually closed (no auto-dismiss)
}

// Make close function globally available
window.closeCheckinNotification = function(notificationId) {
  const element = document.getElementById(notificationId);
  if (element) {
    element.style.animation = 'fadeOut 0.3s ease-out';
    setTimeout(() => element.remove(), 300);
  }
}

function playNotificationSound() {
  try {
    const audioContext = new (window.AudioContext || window.webkitAudioContext)();
    const oscillator = audioContext.createOscillator();
    const gainNode = audioContext.createGain();
    
    oscillator.connect(gainNode);
    gainNode.connect(audioContext.destination);
    
    oscillator.frequency.value = 800;
    oscillator.type = 'sine';
    gainNode.gain.setValueAtTime(0.1, audioContext.currentTime);
    gainNode.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + 0.3);
    
    oscillator.start(audioContext.currentTime);
    oscillator.stop(audioContext.currentTime + 0.3);
  } catch (e) {
    console.log("Audio context not available");
  }
}

// Add CSS animations
if (!document.getElementById('checkin-notification-styles')) {
  const style = document.createElement('style');
  style.id = 'checkin-notification-styles';
  style.textContent = `
    @keyframes slideInRight {
      0% { transform: translateX(100%); opacity: 0; }
      100% { transform: translateX(0); opacity: 1; }
    }
    @keyframes fadeOut {
      0% { opacity: 1; }
      100% { opacity: 0; }
    }
    .checkin-notification:hover {
      transform: translateX(-5px);
      transition: transform 0.2s ease;
    }
  `;
  document.head.appendChild(style);
}
